import { Stack } from '@mui/material'

import { useMemo } from 'react'
import BreadCrumbsGroup from 'ui/breadCrumbs/BreadCrumbsGroup'

import { GroupsStatusTabs } from '../../../models/IGroup'

type GroupsFiltersProps = {
	selectedStatuses: GroupsStatusTabs[]
	onToggleStatus: (status: GroupsStatusTabs) => void
	onRemoveStatus: (status: GroupsStatusTabs) => void
	availableStatuses: Set<GroupsStatusTabs> | null
	statusTabs: {
		title: string
		key: GroupsStatusTabs
	}[]

	barns: { id: number; title: string }[]
	selectedBarns: (string | number)[]
	onToggleBarn: (id: string | number) => void
	onRemoveBarn: (id: string | number) => void
	availableBarns: Set<number> | null
	showBarnsFilter: boolean
}

export const GroupsFilters = ({
	selectedStatuses,
	onToggleStatus,
	onRemoveStatus,
	availableStatuses,
	statusTabs,

	barns,
	selectedBarns,
	onToggleBarn,
	onRemoveBarn,
	availableBarns,
	showBarnsFilter,
}: GroupsFiltersProps) => {
	const statusBreadcrumbs = useMemo(() => {
		return statusTabs.map(tab => {
			const isAvailable =
				availableStatuses === null || availableStatuses.has(tab.key)

			return {
				id: tab.key,
				title: tab.title,
				selected: selectedStatuses.includes(tab.key),
				disabled: !isAvailable,
			}
		})
	}, [selectedStatuses, availableStatuses, statusTabs])

	const barnsBreadcrumbs = useMemo(() => {
		return barns.map(barn => ({
			id: barn.id,
			title: barn.title,
			selected: selectedBarns.includes(barn.id),
			disabled:
				!selectedBarns.includes(barn.id) &&
				availableBarns !== null &&
				!availableBarns.has(barn.id),
		}))
	}, [barns, selectedBarns, availableBarns])

	return (
		<Stack direction='column' gap='12px'>
			<Stack direction='row' alignItems='center' justifyContent='space-between'>
				<BreadCrumbsGroup
					handleActiveFilter={onToggleStatus}
					handleRemoveFilter={onRemoveStatus}
					array={statusBreadcrumbs}
				/>
			</Stack>

			{showBarnsFilter && (
				<BreadCrumbsGroup
					handleActiveFilter={onToggleBarn}
					handleRemoveFilter={onRemoveBarn}
					array={barnsBreadcrumbs}
				/>
			)}
		</Stack>
	)
}
